<template>
  <div>
    <AverageReadinessBanner
      :averageReadiness="averageReadiness"
      :last_month_averageReadiness="last_month_averageReadiness"
    />
    <div class="employees-readiness-tab">
      <EmployeesReadinessTable
        :employees="employees"
        :filterGroups="filterGroups"
        :appliedFilters="appliedFilters"
        :searchText="searchText"
        :totalCount="totalCount"
        :currentPage="currentPage"
        :itemsPerPage="itemsPerPage"
        :toggleLoader="toggleLoader"
        @onChatterClick="handleChatterClick"
        @onSearch="handleSearch"
        @onFilterChange="handleFilterChange"
        @onRemoveFilter="handleRemoveFilter"
        @onClearFilters="handleClearFilters"
        @onExcludeChange="handleExcludeChange"
        @onPaginationChange="handlePaginationChange"
      />
    </div>
  </div>
</template>

<script setup>
import EmployeesReadinessTable from "@components/EmployeesReadinessTable/EmployeesReadinessTable";
import AverageReadinessBanner from "@components/AverageReadinessBanner/AverageReadinessBanner.vue";

const props = defineProps({
  employees: {
    type: Array,
    default: () => [],
  },
  averageReadiness: {
    type: Number,
    default: 0,
  },
  last_month_averageReadiness: {
    type: Number,
    default: 0,
  },
  filterGroups: {
    type: Array,
    default: () => [],
  },
  appliedFilters: {
    type: Array,
    default: () => [],
  },
  searchText: {
    type: String,
    default: "",
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  currentPage: {
    type: Number,
    default: 1,
  },
  itemsPerPage: {
    type: Number,
    default: 10,
  },
  toggleLoader: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["onChatterClick", "onSearch", "onFilterChange", "onRemoveFilter", "onClearFilters", "onExcludeChange", "onPaginationChange"]);

const handleChatterClick = (employee) => {
  emit("onChatterClick", employee);
};

const handleSearch = (text) => {
  emit("onSearch", text);
};

const handleFilterChange = (filters) => {
  emit("onFilterChange", filters);
};

const handleRemoveFilter = (filter) => {
  emit("onRemoveFilter", filter);
};

const handleClearFilters = () => {
  emit("onClearFilters");
};

const handleExcludeChange = (data) => {
  emit("onExcludeChange", data);
};

const handlePaginationChange = (data) => {
  emit("onPaginationChange", data);
};

</script>
<style>
.employees-readiness-tab {
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 100px;
}
</style>